import React from 'react';

import AvatarByAccountId from './AvatarByAccountId';
import AvatarDefault from './AvatarDefault';
import { type AvatarByAccountIdProps, type AvatarDefaultProps } from './types';

const Avatar = (props: AvatarByAccountIdProps | AvatarDefaultProps): React.JSX.Element => {
	const accountId = (props as AvatarByAccountIdProps).accountId;
	const src = (props as AvatarDefaultProps).src;

	if (accountId) {
		return <AvatarByAccountId {...props} accountId={accountId} />;
	}

	return <AvatarDefault {...props} src={src} />;
};

export default Avatar;
